import { typography as altonTheme } from './alton.js'
import { typography as doelgerTheme } from './doelger.js'
import { typography as judahTheme } from './judah.js'
import { typography as oceanBeachTheme } from './ocean-beach.js'
import { typography as systemTheme } from './system.js'
import { TypographyOptions } from './types.js'
import { typography as wordpressKubrickTheme } from './wordpress-kubrick.js'

export enum TypographyTheme {
  alton = 'alton',
  doelger = 'doelger',
  system = 'system',
  judah = 'judah',
  oceanBeach = 'oceanBeach',
  wordpressKubrick = 'wordpressKubrick',
}

export const typographyThemes: Record<TypographyTheme, TypographyOptions> = {
  [TypographyTheme.system]: systemTheme,
  [TypographyTheme.alton]: altonTheme,
  [TypographyTheme.doelger]: doelgerTheme,
  [TypographyTheme.judah]: judahTheme,
  [TypographyTheme.oceanBeach]: oceanBeachTheme,
  [TypographyTheme.wordpressKubrick]: wordpressKubrickTheme,
}
